<script>
import formatDate from '@utils/format-date'
import message, { messageError, messageSuccess } from "@utils/message"
import formMixin from "./mixins/form";
import { categoryOptions, sizeOptions } from "@utils/ipetbooking-options";
import { getDefaultCategory, getDefaultSize } from "@utils/ipetbooking-get-default";
import _uniq from "lodash/uniq";
import { authComputed, merchantComputed } from '@store/helpers'
const DEFAULT_SUBMIT_DATA = {
  id: '',
  name: '',
  gender: 'female',
  categoryAlias: '',
  breed: '',
  sizeAlias: '',
  birthday: '',
  avatar: '',
  phoneCode: '+886',
  phoneNumber: '',
  phone:'',
};

export default {
  name:'FormPet',
  components:{
    CountryCodePicker: () => import("@components/Country/CountryCodePicker"),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'add',
      validator(value) {
        return [
          'add',
          'edit',
        ].includes(value)
      },
    },
    textType: {
      type: String,
      default: 'reservation',
      validator(value) {
        return [
          'reservation',
          'prepaid',
        ].includes(value)
      },
    },
    title: {
      type: String,
      default: '',
    },
    applicableCategoryList: {
      type: Array,
      default: () => {
        return []
      }
    },
    applicableSizeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      errorMessage: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date();
        },
      },
      // loadingRemoveMemberPetList: false,
      tempAavtarFile: null
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    isIncludesSizeList() {
      return this.applicableSizeList.map(item => item.alias)
        .includes(this.FormMixSubmitData.sizeAlias)
    },
    applicableCategoryTitle() {
      return _uniq(this.applicableCategoryList.map(item => item.title))
        .join(',');
    },
    applicableSizeTitle() {
      return _uniq(this.applicableSizeList.map(item => item.title))
        .join(',');
    },
    formatAlertApplicableText() {
      const isIncludeApplicableCategory = this.applicableCategoryList.length === 0 || this.applicableCategoryList.map(item => item.alias)
        .includes(this.FormMixSubmitData.categoryAlias);
      const isIncludeApplicableSize = this.applicableSizeList.length === 0 || this.applicableSizeList.map(item => item.alias)
        .includes(this.FormMixSubmitData.sizeAlias);

      const text1 = () => {
        const text1Array = [];

        if(!isIncludeApplicableCategory) {
          text1Array.push(`「${this.$t('site.FORM_CATEGORY')}」`)
        }

        if(!isIncludeApplicableSize) {
          text1Array.push(`「${this.$t('site.FORM_SIZE')}」`)
        }

        return text1Array.join(',')
      };

      const text2 = () => {
        const text2Array = [];

        if(!isIncludeApplicableCategory) {
          text2Array.push(`「${this.$t('site.FORM_CATEGORY')}：${this.applicableCategoryTitle}」`)
        }

        if(!isIncludeApplicableSize) {
          text2Array.push(`「${this.$t('site.FORM_SIZE')}：${this.applicableSizeTitle}」`)
        }

        return text2Array.join(',')
      };

      const textTypeText = () => {
        const textTypeTextMap = {
          'reservation': {
            text1: '目前預約中的服務',
            text2: '服務'
          },
          'prepaid': {
            text1: `目前選擇的${this.currentMerchant.prepaidSetting.title || this.$t('site.PREPAID_TITLE')}`,
            text2: `${this.currentMerchant.prepaidSetting.title || this.$t('site.PREPAID_TITLE')}`
          }
        };

        return textTypeTextMap[this.textType]
      };

      return isIncludeApplicableCategory && isIncludeApplicableSize
        ? ''
        : `您所選的${text1()}不適用${textTypeText().text1} 此${textTypeText().text2}適用${this.$t('site.USER')}為：${text2()}`
    },
    isDeleteMemberMedia() {
      return (this.FormMixTempSubmitData.avatar !== this.FormMixSubmitData.avatar)
        && this.FormMixTempSubmitData.avatar;
    },
    isUploadMemberMedia() {
      return (this.FormMixTempSubmitData.avatar !== this.FormMixSubmitData.avatar)
        && this.FormMixSubmitData.avatar;
    },
  },
  mounted() {
    const initFormMixSubmitDataCategoryAlias = () => {
      const categoryAlias = () => {
        if(this.type === 'edit') {
          return this.FormMixSubmitData.categoryAlias
        }

        if(this.type === 'add') {
          return this.applicableCategoryList[0]?.alias || ''
        }
      };

      this.FormMixSubmitData.categoryAlias = getDefaultCategory(categoryAlias()) || DEFAULT_SUBMIT_DATA.categoryAlias;
    };

    const initFormMixSubmitDataSizeAlias = () => {
      const sizeAlias = this.type === 'edit'
        ? this.FormMixSubmitData.sizeAlias
        : '';

      this.setFormMixSubmitDataSizeAlias({ sizeAlias });
    };

    const initFormMixSubmitDataPhone = () => {
      if(this.type === 'edit') {
        this.FormMixSubmitData.phoneCode = this.FormMixTempSubmitData.phone ? this.FormMixTempSubmitData.phone.split('-')[0] : '+886'
        this.FormMixSubmitData.phoneNumber = this.FormMixTempSubmitData.phone ? this.FormMixTempSubmitData.phone.split('-')[1] : ''
      }
    }

    initFormMixSubmitDataCategoryAlias();
    initFormMixSubmitDataSizeAlias();
    this.$FormMixinInitTempSubmitData()
    initFormMixSubmitDataPhone()
  },
  methods: {
    formatDate,
    categoryOptions,
    sizeOptions,
    onCancel() {
      this.$emit('cancel')
    },
    onDelete() {
      this.$confirm(`此筆${this.$t('site.USER')}資料將被永久刪除。<br>您確定要刪除嗎？`, `刪除${this.$t('site.USER')}資料`, {
        customClass: 'isStyleBase isReverse',
        confirmButtonText: '確認刪除',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          if(this.isDeleteMemberMedia) {
            this.tryToDeleteMemberMedia()
              .then(() => {
                this.tryToRemoveMemberPetList()
              })
          } else {
            this.tryToRemoveMemberPetList()
          }
        })
        .catch(() => {
          message('已取消');
        })
    },
    async onSubmit() {
      this.tryToCheckUploadOrDeleteMemberMedia()
        .then(() => {
          this.tryToStoreMemberPet();
        })
    },
    tryToStoreMemberPet() {
      this.$store.dispatch('auth/storeMemberPet', {
        ...this.FormMixSubmitData,
        id: this.type === 'edit'
          ? this.FormMixSubmitData.id
          : undefined,
      })
        .then((response) => {
          this.FormMixSubmitData.id = response.id;
          this.$FormMixinOnSubmitSuccess({
            params: {
              type: this.type
            }
          });
        })
    },
    tryToRemoveMemberPetList() {
      // this.loadingRemoveMemberPetList = true;

      this.$store.dispatch('auth/removeMemberPetList', {
        ids: [this.FormMixSubmitData.id]
      })
        .then(() => {
          this.$FormMixinOnSubmitSuccess({
            params: {
              type: 'remove'
            }
          });
        })
        .finally(() => {
          // this.loadingRemoveMemberPetList = false;
        })
    },
    async tryToCheckUploadOrDeleteMemberMedia() {
      const dispatchList = [];

      if(this.isDeleteMemberMedia) {
        dispatchList.push(this.tryToDeleteMemberMedia([
          this.FormMixTempSubmitData.avatar
        ]))
      }

      if(this.isUploadMemberMedia) {
        let formData = new FormData();
        formData.append('file', this.tempAavtarFile?.raw);

        dispatchList.push(this.tryToUploadMemberMedia(formData))
      }

      await Promise.all(dispatchList);

      return true
    },
    async tryToUploadMemberMedia(formData) {
      await this.$store.dispatch('auth/uploadMemberMedia', formData)
        .then((response) => {
          this.FormMixSubmitData.avatar = response.items.path;
        })
        .catch(() => {
          if(this.isUploadMemberMedia) {
            this.FormMixSubmitData.avatar = this.FormMixTempSubmitData.avatar;
          }

          messageError('圖片上傳失敗');
        })
    },
    async tryToDeleteMemberMedia(paths) {
      await this.$store.dispatch('auth/deleteMemberMedia', paths)
        .then(() => {
          this.FormMixSubmitData.avatar = '';
        })
        .catch(() => {
          if(this.isDeleteMemberMedia && !this.isUploadMemberMedia) {
            this.FormMixSubmitData.avatar = this.FormMixTempSubmitData.avatar;
          }

          messageError('圖片刪除失敗');
        })
    },
    onChangeUpload(file) {
      const checkFile = () => {
        const isTureType = [
          'image/jpeg',
          'image/png'
        ].includes(file.raw.type);

        const isTureSize = file.raw.size / 1024 / 1024 < 2;

        if(!isTureType) {
          this.errorMessage = `${this.$t('site.USER')}照片只能是 JPG / PNG 格式`;
        }
        if(!isTureSize) {
          this.errorMessage = `您的${this.$t('site.USER')}照片超過2MB，請重新上傳`;
        }

        return isTureType && isTureSize;
      };

      this.errorMessage = '';

      if(checkFile()) {
        this.tempAavtarFile = file;
        this.FormMixSubmitData.avatar = file.url;
      }
    },
    onUpdateError() {

    },
    removePetImageUrl() {
      this.FormMixSubmitData.avatar = '';
      this.tempAavtarFile = null;
    },
    onChangeCategory() {
      this.setFormMixSubmitDataSizeAlias();
    },
    onPreview(file) {

    },
    setFormMixSubmitDataSizeAlias({ sizeAlias } = {}) {
      const applicableSizeAlias = this.applicableSizeList[0]?.alias || '';

      this.FormMixSubmitData.sizeAlias = getDefaultSize(sizeAlias || applicableSizeAlias, this.FormMixSubmitData.categoryAlias) || DEFAULT_SUBMIT_DATA.sizeAlias
    },
    tryToStoreInfo() {
      const {  extraInfos: { birthday, ...resExtraInfos }} = this.currentMember;
      this.$store.dispatch('auth/storeMember', {
        gender: this.FormMixSubmitData.gender,
        fullName: this.FormMixSubmitData.name,
        extraInfos: {
          ...resExtraInfos,
          birthday: this.FormMixSubmitData.birthday
        }
      })
        .then(() => {
          messageSuccess('會員資料已修改');
          // this.$FormMixinOnSubmitSuccess();
          // this.$FormMixinInitTempSubmitData();
          this.tryToFetchMemberInfo()
        })
    },
    tryToFetchMemberInfo() {
      this.$store.dispatch('auth/fetchMember')
    },
  }
}
</script>
<!-- section template -->
<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }">
    <el-form
      ref="form"
      v-loading="$isLoading('removeMemberPetList')"
      :element-loading-text="`正在刪除${$t('site.USER')}資料...`"
      :model="FormMixSubmitData"
      label-position="top"
      class="isStyleBase"
      :class="[$style.formPet, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
      @submit.prevent.native="handleSubmit(onSubmit)"
    >
      <div
        v-if="!!title"
        class="formPet__title"
      >
        {{ title }}
      </div>
      <div class="text-center">
        <el-upload
          class="el-upload isStylePet"
          action=""
          list-type="picture"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="onChangeUpload"
          :on-preview="onPreview"
        >
          <div
            v-if="!!FormMixSubmitData.avatar"
            :style="{ backgroundImage: `url('${ FormMixSubmitData.avatar }')` }"
            class="el-upload__img"
          ></div>
          <div
            v-else
            :style="{ backgroundImage: `url('${ require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
            class="el-upload__img"
          ></div>
          <template v-if="!!FormMixSubmitData.avatar">
            <el-dropdown
              class="el-upload__more"
              hide-on-click
              placement="right"
              trigger="click"
            >
              <BaseButton
                class="isStylePrimary isCircle isSmall"
                @click.stop.prevent
              >
                <i class="fal fa-edit"></i>
              </BaseButton>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-upload
                    class="el-upload isStyleDropdown"
                    action=""
                    list-type="picture"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="onChangeUpload"
                    :on-error="onUpdateError"
                    :on-preview="onPreview"
                  >
                    <i class="fal fa-edit mr-2"></i>更換{{ $t('site.USER') }}照片(圖檔最大2MB)
                  </el-upload>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="!!FormMixSubmitData.avatar"
                  @click.native="removePetImageUrl"
                >
                  <i class="fal fa-trash-alt mr-2"></i>刪除照片
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <div class="el-upload__more">
              <BaseButton
                class="isStylePrimary isCircle isSmall"
              >
                <i class="fal fa-plus"></i>
              </BaseButton>
            </div>
          </template>
        </el-upload>
        <div class="mb-3">
          <el-alert
            v-if="errorMessage"
            :title="errorMessage"
            type="error"
            show-icon
            :closable="false"
            class="isStyleBase"
          >
          </el-alert>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('site.FORM_NAME')"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="name" :label="$t('site.FORM_NAME')" class="isRequired">
              <el-input
                v-model="FormMixSubmitData.name"
                :placeholder="$globalIsDingBeauty ? '例：王小明' : '例：小白'"
              >
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('site.FORM_GENDER')"
            rules=""
          >
            <el-form-item :error="errors[0]" prop="name" :label="$t('site.FORM_GENDER')">
              <el-radio-group v-model="FormMixSubmitData.gender">
                <el-radio label="male">{{ $t('site.FORM_GENDER_MALE') }}</el-radio>
                <el-radio label="female">{{ $t('site.FORM_GENDER_FEMALE') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div v-if="currentMerchant.petCategories.length > 1" class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('site.FORM_CATEGORY')"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="pet" :label="$t('site.FORM_CATEGORY')" class="isRequired">
              <el-select
                v-model="FormMixSubmitData.categoryAlias"
                :placeholder="`請選擇${$t('site.FORM_CATEGORY')}`"
                @change="onChangeCategory"
              >
                <el-option
                  v-for="(option, $index) in categoryOptions()"
                  :key="`categoryOptions-${$index}`"
                  :label="option.text"
                  :value="option.value">
                </el-option>
              </el-select>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div v-if="!$globalIsDingBeauty" class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            name="品種"
            rules=""
          >
            <el-form-item :error="errors[0]" prop="breed" label="品種">
              <el-input
                v-model="FormMixSubmitData.breed"
                placeholder="例：博美犬"
              >
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div v-if="currentMerchant.petCategories[0].children.length > 1" class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('site.FORM_SIZE')"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="size" :label="$t('site.FORM_SIZE')" class="isRequired">
              <el-select
                v-model="FormMixSubmitData.sizeAlias"
                :placeholder="`請選擇${$t('site.FORM_SIZE')}`"
              >
                <el-option
                  v-for="(option, $index) in sizeOptions(FormMixSubmitData.categoryAlias)"
                  :key="`sizeOptions-${$index}`"
                  :label="option.text"
                  :value="option.value">
                </el-option>
              </el-select>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div v-if="$globalIsDingBeauty" class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="FormMixSubmitData.phoneCode === '+886' ? 'require|phone' : 'require'"
            name="手機號碼"
          >
            <el-form-item :error="errors[0]" label="手機號碼" prop="phoneNumber" class="isRequired">
              <el-input
                ref="phoneNumber"
                v-model="FormMixSubmitData.phoneNumber"
                placeholder="手機號碼"
                autocomplete="tel"
                inputmode="tel"
              >
                <CountryCodePicker slot="prepend" v-model="FormMixSubmitData.phoneCode"/>
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div>
        <div class="col-md-6">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('site.FROM_BIRTHDAT')"
            rules=""
          >
            <el-form-item :error="errors[0]" prop="birthday" :label="$t('site.FROM_BIRTHDAT')">
              <el-date-picker
                v-model="FormMixSubmitData.birthday"
                type="date"
                :editable="false"
                :clearable="false"
                :prefix-icon="'none'"
                format="yyyy/MM/dd"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                :popper-class="$globalIsDingBeauty ? 'isStyleSquare' : ''"
                :placeholder="`請選擇${$t('site.FROM_BIRTHDAT')}`"
              >
              </el-date-picker>
            </el-form-item>
          </ValidationProvider>
        </div>
      </div>
      <div class="mb-4">
        <el-alert
          v-if="formatAlertApplicableText"
          :title="formatAlertApplicableText"
          type="error"
          show-icon
          :closable="false"
          class="isStyleBase"
        >
        </el-alert>
      </div>
      <BaseButton
        :disabled="invalid"
        :loading="$isLoading('storeMemberPet') || $isLoading('uploadMemberMedia') || $isLoading('deleteMemberMedia')"
        class="isStylePrimary isFull mb-3"
        :class="{ 'isRadius': $globalIsJtails }"
        type="submit"
      >
        {{
          type === 'add'
            ? '確認新增'
            : '儲存修改'
        }}
      </BaseButton>
      <BaseButton
        v-if="$globalIsDingBeauty"
        :disabled="invalid"
        :loading="$isLoading('storeMember')"
        class="isStylePrimary isFull mb-3"
        :class="{ 'isRadius': $globalIsJtails }"
        @click="tryToStoreInfo"
      >
        成為會員資料
      </BaseButton>
      <BaseButton
        class="isStylePrimary isOutline3 isFull"
        :class="{ 'isRadius': $globalIsJtails }"
        @click="onCancel"
      >
        取消
      </BaseButton>
      <div class="text-center">
        <BaseButton
          v-if="type === 'edit'"
          class="isStylePrimary isTextUnderline2 mt-4 text-center"
          @click="onDelete"
        >
          刪除
        </BaseButton>
      </div>
    </el-form>
    <BasePre>tempAavtarFile {{ tempAavtarFile }}</BasePre>
    <BasePre>FormMixTempSubmitData: {{ FormMixTempSubmitData }}</BasePre>
    <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
    <BasePre>applicableCategoryList:{{ applicableCategoryList }}</BasePre>
    <BasePre>applicableSizeList:{{ applicableSizeList }}</BasePre>
  </ValidationObserver>
</template>
<!-- section style -->
<style lang="scss" module>
.formPet {
  :global {
    .formPet {
      &__title {
        margin-bottom: 2.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        text-align: center;
        color: $color-primary-dark;
      }

      &__submit {
        margin-bottom: 22px;
      }

    }
  }
  &.isStyleDingBeauty {
    :global {
      .formPet {
        &__title {
          font-size: 1.125rem;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
